// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__SOqPO","validationTips":"StatementDescriptor_validationTips__20s3U"};